import 'normalize.css'
import 'reset-css'
import './style/style.scss'
import React from 'react'
import Router from './router'

export default () => <Router />
